import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

const BackToConversation = ({ linkText }) => (
    <div className="r-pal">
        <Link to="/samtale" className="strong">
            <svg className="valign-middle mrm" width="13" height="13">
                <use xlinkHref="#icon-arrow-left" />
            </svg>
            {linkText}
        </Link>
    </div>
);

BackToConversation.propTypes = {
    linkText: PropTypes.string,
};

BackToConversation.defaultProps = {
    linkText: 'Gå til samtalen',
};

export default BackToConversation;



// WEBPACK FOOTER //
// ./safeTrade/backToConversation.jsx